import { styled } from "@mui/material";

export const FooterContainer = styled("div")(() => ({
  zIndex: 101,
}));

export const MobileFooterContainer = styled("div")(() => ({
  width: "100%",
}));

export const FooterInfoContainer = styled("div")(() => ({
  padding: "6px 16px 6px 16px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: "100%",
  backgroundColor: "#2A2E3C",
  marginTop: "2rem",
}));

export const FooterCopyrightContainer = styled("div")(() => ({
  backgroundColor: "#1E212B",
  height: "4rem",
  width: "100%",
  display: "flex",
  justifyContent: "center",
  padding: "10px 0 10px 10px"
}));

export const FooterTermsContainer = styled("div")(() => ({
  backgroundColor: "#2A2E3C",
  width: "100%",
  display: "flex",
  justifyContent: "center",
}));

export const FooterInfoBlock = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: "0.25rem",
}));

export const FooterInfoBlockItem = styled("div")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "0.6rem",
}));
